import Vue from "vue";
import axios from "axios";
import store from "@/store";

import mApp from "@/modules/app";
import mUtils from "@/modules/utils";
import { APP_MODE } from "@/modules/enums";

export default {
  isServerOnline() {
    if (store.getters.notCheckServerOnline) {
      return new Promise(resolve => {
        resolve({ result: "ok" });
      });
    } else
      return mApp.apiPost(store.getters.doApiUrl + "/isonline", { sessionKey: store.state.Store.store.sessionKey });
  },

  async isMenuDisabled() {
    let resp = await mApp.apiPost(store.getters.doApiUrl + "/ismenudisabled", store.state.appToken);
    if (resp.result == "ok") return resp.disabled;
    else return false;
  },

  getServerStatus() {
    return mApp.apiPost(store.getters.doApiUrl + "/getserverstatus", {
      sessionKey: store.state.Store.store.sessionKey,
    });
  },

  getFullMenu(menuType, priceLevel) {
    return mApp.apiPost(store.getters.doApiUrl + "/v2/getfullmenu", {
      sessionKey: store.state.Store.store.sessionKey,
      menuTypes: menuType ? [menuType] : undefined,
      priceLevel: priceLevel,
    });
  },

  addItemLike(itemID) {
    return mApp.apiPost(store.getters.doApiUrl + "/v2/additemlike", {
      sessionKey: store.state.Store.store.sessionKey,
      itemID: itemID,
    });
  },

  getTable(params) {
    if (!params.tableID && !params.tableName && !params.tableGroupID) return null;

    let sessionKey = params.sessionKey;
    if (sessionKey == null && store.state.Store.store) sessionKey = store.state.Store.store.sessionKey;

    return mApp.apiPost(store.getters.doApiUrl + "/gettables", {
      sessionKey: sessionKey,
      tableID: params.tableID,
      tableName: params.tableName,
      tableGroupID: params.tableGroupID,
    });
  },

  getCategories(menuType, catID) {
    return mApp.apiPost(store.getters.doApiUrl + "/getcategories", {
      sessionKey: store.state.Store.store.sessionKey,
      menuTypes: [menuType],
      catID: catID,
      menu: true,
    });
  },

  getItems(payload) {
    return mApp.apiPost(store.getters.doApiUrl + "/v2/getitems", {
      sessionKey: store.state.Store.store.sessionKey,
      menuTypes: payload.menuType ? [payload.menuType] : undefined,
      catID: payload?.ID,
      catBarcode: payload?.catBarcode,
      barcode: payload?.barcode,
      favorite: payload?.favorite,
      redeem: payload?.redeem,
      redeemable: payload?.redeemable,
      fullmenu: true,
      //menu: true,
      //bundlemenu: bundleMenu,
    });
  },

  getItemInventory(items) {
    return mApp.apiPost(store.getters.doApiUrl + "/v2/getiteminventory", {
      sessionKey: store.state.Store.store.sessionKey,
      items: items,
      orderId: store.state.Order.order.orderUUID,
    });
  },

  updateItemAllocation(items) {
    return mApp.apiPost(store.getters.doApiUrl + "/v2/itemallocation", {
      sessionKey: store.state.Store.store.sessionKey,
      update: {
        items: items,
        orderId: store.state.Order.order.orderUUID,
      },
    });
  },

  sendOrder(feed) {
    let fn = "/v2/addorder";
    if (store.state.serverBuildNo > 0 && store.state.serverBuildNo < 183) fn = "/addfeed";

    return mApp.apiPost(store.getters.doApiUrl + fn, {
      sessionKey: store.state.Store.store.sessionKey,
      feed: feed,
    });
  },

  addMemberGiftcard(memberCode, amount) {
    return mApp
      .apiPost(store.getters.dcApiUrl + "/giftcard", {
        sessionKey: store.getters.serviceSessionKey,
        add: [{ MemberCode: memberCode, Amount: amount }],
      })
      .then(resp => {
        return resp.add[0];
      });
  },

  linkMemberGiftcard(memberCode, cardCode) {
    return mApp
      .apiPost(store.getters.dcApiUrl + "/giftcard", {
        sessionKey: store.getters.serviceSessionKey,
        put: [{ MemberCode: memberCode, CardCode: cardCode }],
      })
      .then(resp => {
        return resp.put[0];
      });
  },

  getMemberGiftcardTrans(memberCode, cardCode) {
    return mApp
      .apiPost(store.getters.dcApiUrl + "/giftcardtrans", {
        sessionKey: store.getters.serviceSessionKey,
        storeSessionKey: store.state.Store.store ? store.state.Store.store.sessionKey : undefined,
        list: [{ MemberCode: memberCode, CardCode: cardCode, RecLimit: 50 }],
      })
      .then(resp => {
        return resp.list[0];
      });
  },

  reloadMemberGiftcard(payload) {
    let n_remark = "Reload";
    if (payload.remark) n_remark = payload.remark;
    else if (store.getters.service?.giftcardReloadLabel?.en) n_remark = store.getters.service.giftcardReloadLabel.en;
    else if (store.getters.service?.giftcardReloadLabel?.def) n_remark = store.getters.service.giftcardReloadLabel.def;
    let n_message = "Mobile order";
    if (payload.message) n_message = payload.message;

    return mApp
      .apiPost(store.getters.dcApiUrl + "/giftcardtrans", {
        sessionKey: store.getters.serviceSessionKey,
        storeSessionKey: store.state.Store.store ? store.state.Store.store.sessionKey : undefined,
        add: [
          {
            CardCode: payload.cardCode,
            Amount: payload.amount,
            Remark: n_remark,
            Message: n_message,
            AutoCreation: true,
            Sms: {
              MembershipName: store.getters.memberCompanyName,
              MemberCode: store.getters.memberCode,
              StoreName: store.getters.storeName,
              SenderName: store.getters.memberName,
              SenderPhoneId:
                store.getters.memberPhoneId != "" ? store.getters.memberPhoneId : store.getters.memberPhoneNo,
              RecipientPhoneId: payload.recipientPhoneId,
              RecipientMessage: payload.recipientMessage,
            },
          },
        ],
      })
      .then(resp => {
        return resp.add[0];
      });
  },

  redeemMemberGiftcard(cardCode, redeemValue) {
    let n_remark = "Redeem";
    if (store.getters.service?.giftcardRedeemLabel?.en) n_remark = store.getters.service.giftcardRedeemLabel.en;
    else if (store.getters.service?.giftcardRedeemLabel?.def) n_remark = store.getters.service.giftcardRedeemLabel.def;
    return mApp
      .apiPost(store.getters.dcApiUrl + "/giftcardtrans", {
        sessionKey: store.getters.serviceSessionKey,
        storeSessionKey: store.state.Store.store ? store.state.Store.store.sessionKey : undefined,
        add: [
          {
            CardCode: cardCode,
            Amount: -redeemValue,
            Remark: n_remark,
            Message: "Mobile order",
            EventMetadata: {
              orderUUID: store.state.Order.order.orderUUID,
            },
            Sms: store.state.member
              ? {
                  MembershipName: store.getters.memberCompanyName,
                  StoreName: store.getters.storeName,
                  SenderName: store.getters.memberName,
                  SenderPhoneId:
                    store.getters.memberPhoneId != "" ? store.getters.memberPhoneId : store.getters.memberPhoneNo,
                }
              : undefined,
          },
        ],
      })
      .then(resp => {
        return resp.add[0];
      });
  },

  getNewsFeed() {
    let n_store = undefined;
    if (Vue.prototype.$appMode == APP_MODE.WEB && store.state.Store.store)
      n_store = store.state.Store.store.companyCode;

    return mApp
      .apiPost(store.getters.dcApiUrl + "/newsfeed", {
        sessionKey: store.getters.serviceSessionKey,
        get: { Store: n_store, Language: "all" },
      })
      .then(resp => {
        return resp.get;
      });
  },

  // obsoleted
  requestSmsVerificationCode(phoneId) {
    let n_sessionKey = store.state.appSessionKey;
    if (Vue.prototype.$appMode == APP_MODE.WEB && store.state.Store.store)
      n_sessionKey = store.state.Store.store.sessionKey;

    return mApp.apiPost(store.getters.dcApiUrl + "/sms", {
      sessionKey: n_sessionKey,
      validate: { Phone: phoneId },
    });
  },

  // obsoleted
  verifySmsVerificationCode(phoneId, vcode, vtoken) {
    let n_sessionKey = store.state.appSessionKey;
    if (Vue.prototype.$appMode == APP_MODE.WEB && store.state.Store.store)
      n_sessionKey = store.state.Store.store.sessionKey;

    return mApp.apiPost(store.getters.dcApiUrl + "/sms", {
      sessionKey: n_sessionKey,
      verify: { Phone: phoneId, Code: vcode, Token: vtoken },
    });
  },

  doorDashQuote(params) {
    console.log("doorDashQuote", params);

    let pickupTime = params?.pickupTime;
    let dropOffTime = params?.dropOffTime;
    if (dropOffTime != null)
      pickupTime = undefined;
    return mApp
      .apiPost(store.getters.dcApiUrl + "/doordash", {
        sessionKey: store.state.Store.store.sessionKey,
        quote: {
          dropoff_address: mUtils.addressToString(params?.dropOffAddress),
          dropoff_phone_number: params?.dropOffAddress.phone1,
          dropoff_instructions: params?.dropOffAddress.remark,
          dropoff_contact_family_name: params?.dropoffContact?.lastName,
          dropoff_contact_given_name: params?.dropoffContact?.firstName,
          dropoff_time: dropOffTime,
          pickup_time: pickupTime,
          items: params?.items,
          order_value: params?.orderValue,
          tip: params?.tip,
        },
      })
      .then(resp => {
        console.log("doorDashQuote resp", resp);
        if (resp.quote) return resp.quote;
        else return { result: resp.result };
      });
  },

  doorDashUpdate(params) {
    console.log("doorDashUpdate", params);

    return mApp
      .apiPost(store.getters.dcApiUrl + "/doordash", {
        sessionKey: store.state.Store.store.sessionKey,
        update: {
          external_delivery_id: params?.doorDashDriveID,
          dropoff_address: mUtils.addressToString(params?.address),
          dropoff_phone_number: params?.address.phone1,
          dropoff_instructions: params?.address.remark,
          dropoff_time: params?.time,
        },
      })
      .then(resp => {
        console.log("doorDashUpdate resp", resp);
        if (resp.update) return resp.update;
        else return { result: resp.result };
      });
  },

  doorDashQuery(params) {
    return mApp
      .apiPost(store.getters.dcApiUrl + "/doordash", {
        sessionKey: store.state.Store.store.sessionKey,
        query: {
          external_delivery_id: params?.doorDashDriveID,
        },
      })
      .then(resp => {
        if (resp.query) return resp.query;
        else return { result: resp.result };
      });
  },

  ftsPutOrder() {
    let address = store.state.Order.order.address;
    if (address == null) address = {};

    let addressUnit;
    if (address.unit && address.unit != "") addressUnit = "unit " + address.unit;

    let data = {
      customer: {
        name: store.getters.memberName,
        email: store.getters.memberEmail,
        phone: store.getters.memberPhoneId,
        r_address1: address.street,
        r_address2: addressUnit,
        r_city: address.city,
        r_prov_state: address.province,
        r_country: "CA",
        r_postal_code: address.postal,
      },
      order: {},
    };

    return mApp.apiPost(store.getters.dcApiUrl + "/fts", {
      sessionKey: store.state.Store.store.sessionKey,
      data: data,
    });
  },

  getDistanceMatrix(coords1, coords2) {
    //console.log("getDistanceMatrix", coords1, coords2);

    var origins = [coords1.lat.toString() + "," + coords1.lng.toString()];
    var destinations = [coords2.lat.toString() + "," + coords2.lng.toString()];
    let jreq = {
      origins: origins,
      destinations: destinations,
      key: Vue.prototype.$GDM_API_KEY,
    };
    let apiUrl = "https://api.mrsdigi.com/digiCloud/v4.php/gapi/distance";
    let request = JSON.stringify(jreq);

    return axios
      .post(apiUrl, request)
      .then(result => result.data)
      .then(data => {
        return data;
      })
      .catch(error => {
        console.log(error);
      });
  },

  /*
    doorDashDelivery() {
      let lastName = "";
      let firstName = "";
      let pickupPhoneNumber = this.storeAddress.tel;

      if ("lastName" in store.state.Order.order.login) lastName = store.state.Order.order.login.lastName;
      if ("firstName" in store.state.Order.order.login) firstName = store.state.Order.order.login.firstName;
      if (lastName == "" && firstName == "") firstName = store.state.Order.order.login.name;

      if (Vue.prototype.$isValidPhoneNumber(pickupPhoneNumber)) pickupPhoneNumber = "+1" + pickupPhoneNumber;

      let data = {
        pickup_address: {
          unit: store.getters.storeAddress.unit,
          street: store.getters.storeAddress.street,
          city: store.getters.storeAddress.city,
          state: store.getters.storeAddress.province,
          zip_code: store.getters.storeAddress.postal,
        },
        pickup_phone_number: pickupPhoneNumber,
        dropoff_address: {
          unit: store.state.Order.order.address.unit,
          street: store.state.Order.order.address.street,
          city: store.state.Order.order.address.city,
          state: store.state.Order.order.address.province,
          zip_code: store.state.Order.order.address.postal,
        },
        dropoff_instructions: store.state.Order.order.address.remark,
        delivery_time: store.state.Order.order.deliveryTimeTz,
        order_value: Math.floor(store.state.Order.order.subtotal * 100),
        tip: Math.floor(store.state.Order.order.tips * 100),
        customer: {
          first_name: firstName,
          last_name: lastName,
          phone_number: store.state.Order.order.login.phone1,
        },
      };
      let jreq = {
        sessionKey: store.state.Store.store.sessionKey,
        DriveId: store.state.Order.order.doorDashDriveID,
        delivery: { data: data },
      };
      let request = JSON.stringify(jreq);

      return axios
        .post(store.getters.dcApiUrl + "/doordash", request, store.state.httpReqOpt)
        .then((result) => result.data)
        .then((data) => {
          return data.delivery;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    */
};
